
import {map,  catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Secodip } from '../../resource/secodip.resource';
import { FilteredItem } from '../../resource/filteredItem.resource';
import { environment } from '../../../environments/environment';
import { UtilitiesHandler } from '@service/utilities-handlers/utilitiesHandlers';

import { Observable } from 'rxjs';

@Injectable()
export class SecodipService {
  private route: string = 'secodip';
  private filter: Object;

  constructor(
    private http: HttpClient,
    private utilitiesHandler: UtilitiesHandler
  ) { }

  getListBySecodipId(idList: Array<string>): Observable<Secodip[]> {
    this.filter = {
      secodip_id: idList.join(';')
    };

    const api_base_url: string = `${environment.api_base_url}/${this.route}`;
    const params: HttpParams = this.utilitiesHandler.buildParamsApi(this.filter);

    return this.http
      .get(api_base_url, {params}).pipe(
      map((data: any) =>
          data._embedded.secodip
            .map((jsonSecodip: any) =>
              new Secodip(jsonSecodip)
            )
      ))
      .pipe(
        catchError(this.utilitiesHandler.handleErrorApi)
      )
  }

  /**
   * Get list of secodip for filter
   *
   * @param {Object} [filters=null]
   * @returns {Observable<FilteredItem[]>}
   * @memberof SecodipService
   */
  getListForFilter(filters: Object = null): Observable<FilteredItem[]> {
    const api_base_url: string = `${environment.api_base_url}/${this.route}`;
    const params: HttpParams = this.utilitiesHandler.buildParamsApi(filters);

    return this.http
      .get(api_base_url, {params}).pipe(
      map((data: any) =>
        data._embedded.secodip
          .map((jsonSecodip: any) =>
            new Secodip(jsonSecodip)
          )
          .map((secodip: Secodip) =>
            new FilteredItem(secodip)
          )
      ))
      .pipe(
        catchError(this.utilitiesHandler.handleErrorApi)
      )
  }
}
